import i18n from 'i18next';

export const columns = [
  {
    id: 'reportType',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Type'),
    needSorting: true,
  },
  {
    id: 'requestDateKey',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Request Date (UTC)'),
    needSorting: true,
  },
  {
    id: 'recurrenceType',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Scheduler Type'),
    needSorting: true,
  },
  {
    id: 'recurrenceInterval',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Recurring Type'),
    needSorting: true,
  },
  {
    id: 'nextFireDate',
    numeric: true,
    disablePadding: false,
    label: i18n.t('Next Fire Date (UTC)'),
    needSorting: true,
  },
  {
    id: 'action',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Actions'),
    needSorting: false,
    align: 'left',
  },
];
